import PortalLogin from "../components/portalLogin.jsx";
import PortalIndex from "../components/portalIndex.jsx";

import PortalBillingStripe from "../components/portalBillingStripe.jsx";
import PortalSendMagicLink from "../components/portalSendMagicLink.jsx";
import PortalPasswordReset from "../components/portalPasswordReset.jsx";
import PortalPrescriptionRefills from "../components/portalPrescriptionRefills.jsx";

import PortalDoctorMessages from "../components/portalDoctorMessages.jsx";
import PortalPatientCareMessages from "../components/portalPatientCareMessages.jsx";
// import ApolloTest from "../components/apolloTest";

import { chain } from "lodash";

// Name is required here for routeMap lookup
export const portalRoutes = [
  {
    name: "login",
    path: "/me/login",
    component: PortalLogin,
    public: true,
  },
  {
    name: "magicLinkLogin",
    path: "/me/login-send-email",
    component: PortalSendMagicLink,
    public: true,
  },
  {
    name: "passwordReset",
    path: "/me/password-reset",
    component: PortalPasswordReset,
    public: true,
  },
  {
    name: "patientPortalIndex",
    path: "/me/portal",
    component: PortalIndex,
    // public: true,
  },
  {
    // redirect to stripe payment portal
    name: "paymentPortal",
    path: "/me/payment-portal",
    component: PortalBillingStripe,
  },
  {
    name: "doctorMessages",
    path: "/me/messages/doctor",
    component: PortalDoctorMessages,
  },
  {
    name: "patientCareMessages",
    path: "/me/messages/care",
    component: PortalPatientCareMessages,
  },
  {
    name: "refills",
    path: "/me/refills",
    component: PortalPrescriptionRefills,
  },
  {
    name: "redirectRootToPatientPortalIndex",
    path: "/me",
    pathTo: "/me/portal",
    redirect: true,
  },

  // {
  //   path: "/me/apollo",
  //   name: "Apollo Test",
  //   component: ApolloTest
  // }
  // {
  //   path: "/visits/signup-details",
  //   name: "Signup Details",
  //   short: "Sign Up Details",
  //   mini: "SUD",
  //   // icon: PersonAdd,
  //   component: SignUpDetails
  // }
];

// Generate route map
export const routeMap = chain(portalRoutes)
  .keyBy("name")
  .mapValues("path")
  .value();
// console.log("routeMap:", routeMap);
